import React from 'react';
import {ConnectedRouter as Router} from 'connected-react-router';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import Root from 'routes';
import axios from 'axios';
import {IntlProvider} from 'react-intl';
import PubNub from 'pubnub';
import {PubNubProvider} from 'pubnub-react';
import SplashScreen from 'common/components/SplashScreen';
import {store, persistor, history} from 'store/configureStore';
import {setupAxios} from 'store/setupAxios';
import pubnubConfig from './config/pubnub.json';

setupAxios(axios, store);

const pubnub = new PubNub(pubnubConfig);

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<SplashScreen/>} persistor={persistor}>
        <Router history={history}>
          <IntlProvider
            locale={'he'}
            messages={{}}
          >
            <PubNubProvider client={pubnub}>
              <Root/>
            </PubNubProvider>
          </IntlProvider>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
